import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import { Cell, Pie, PieChart } from "recharts";

interface taskSelectProps {
  email: string;
  task: string;
  goTask: (v:string) => void;
  setTaskSelectPageOpen: React.Dispatch<React.SetStateAction<boolean>>
  setTask:React.Dispatch<React.SetStateAction<string>>;
}

const COLORS = ["#03cf5d", "#2e96ff", "#525cdb", "#FF8042"];
const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx,
  cy,
  midAngle,
  innerRadius,
  outerRadius,
  percent,
  payload
}: any) => {
  const radius = innerRadius + (outerRadius - innerRadius) * 0.3;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  // console.log('payload',payload)

  return (
    <React.Fragment>
    <text
      x={x}
      y={y}
      fill="white"
      textAnchor={x > cx ? "start" : "end"}
      // dominantBaseline="central"
      style={{fontSize:"12px",fontWeight:600}}
    >
      {`${(percent * 100).toFixed(0)}%`}
    </text>
    <text
      x={x+15}
      y={y+15}
      fill="black"
      textAnchor={x > cx ? "start" : "end"}
      // dominantBaseline="central"
      style={{fontSize:"10px",fontWeight:600}}
    >
      {`(${payload.value}건)`}
      {/* {`(44,000건)`} */}
    </text>
    </React.Fragment>
  );
};

const TaskSelectDialogPage = (props: taskSelectProps) => {

  const [workerTaskList, setWorkerTaskList] = useState([]);

  const [clickTask, setClickTask] = useState(props.task);

  const myTaskList = async () => {
    api.get('/myTaskList',{params:{email:props.email}})
    .then((res:any) => {
      setWorkerTaskList(res.data.datas);
    
    })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(() => {
    myTaskList()
  },[])

  return (
    <Box >
    <Dialog maxWidth="lg" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>Task 목록</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>

        <Box display="flex">
          <Box sx={{width:"100%", margin:"8px"}}>
            <Box m={1} display="flex" sx={{alignItems:"center"}}>
              {workerTaskList.length > 0 ? workerTaskList.map((task_info:any,index:any)=>{
                let data = [
                  { name: "작업완료", value: task_info.y_cnt },
                  { name: "작업대기", value: task_info.n_cnt }
                ];

                return (
                  <Box sx={{margin:3}} key={index}>
                    <Box sx={{fontWeight:700, marginBottom:"4px", width:"150px"}}>{task_info.task}</Box>
                    <PieChart width={180} height={180}>
                      <Pie
                        isAnimationActive={true}
                        data={data}
                        // cx={145}
                        // cy={155}
                        cx={80}
                        cy={80}
                        labelLine={false}
                        label={renderCustomizedLabel}
                        outerRadius={80}
                        paddingAngle={5}
                        cornerRadius={10}
                        // label
                        // innerRadius={40}
                        // outerRadius={80}
                        fill="#61d173"
                        nameKey="name"
                        dataKey="value"
                      >
                        {data.map((entry: any, index: any) => (
                          <Cell
                            key={`cell-${index}`}
                            fill={COLORS[index % COLORS.length]}
                            onClick={(e) => console.log(e)}
                          />
                        ))}
                      </Pie>
                    </PieChart>
                    <Box>
                      {/* <Box>주제 : {conTypeName[script.con_type] || ''}</Box> */}
                      <Box><b style={{color:"blue"}}></b>총건수 : <b style={{color:"blue"}}>{task_info.y_cnt + task_info.n_cnt}</b> 건</Box>
                      <Box><b style={{color:"#03cf5d"}}>●</b>작업완료 : <b style={{color:"#03cf5d"}}>{task_info.y_cnt}</b> 건</Box>
                      <Box><b style={{color:"#2e96ff"}}>●</b>작업대기 : <b style={{color:"#2e96ff"}}>{task_info.n_cnt}</b> 건</Box>
                      <Box>
                      <Checkbox
                        checked={clickTask == task_info.task.substring(0,2) ? true : false}
                        onChange={(() => setClickTask(task_info.task.substring(0,2)))}
                        inputProps={{ 'aria-label': 'controlled' }}
                      />
                      </Box>
                  </Box>
                  </Box>
                )
              }) : ""}
            </Box>
          </Box>
        </Box>
        {/* </form> */}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setTaskSelectPageOpen(false);
          }}
        >
          취소
        </Button>
        <Button variant="contained" color="error" sx={{fontWeight:700, margin:"8px 16px"}}
          onClick={() => {
            props.setTaskSelectPageOpen(false);
            props.goTask(clickTask)
          }}
        >
          확인
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default TaskSelectDialogPage;
